import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './Form.css';
import { requiredFieldClass } from '../lib/requiredFieldClass';
import { applicationSuccessMessage } from '../lib/applicationSuccessMessage';

const DRAFT_KEY = 'draft_remove';

const RemoveForm = ({ onBack, onNext, isFirstForm, isLastForm, isMultiForm, id, isDraft }) => {
    const [formData, setFormData] = React.useState({
        applicationDate: '',
        reason: ''
    });

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        try {
            const saved = localStorage.getItem(DRAFT_KEY);
            if (saved) setFormData(prev => ({ ...prev, ...JSON.parse(saved) }));
        } catch (_) {}
    }, []);
    // フォーム入力の変更を処理
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    // フォームの送信を処理
    const handleSubmit = async (e) => {
        e.preventDefault();
        const isConfirmed = window.confirm("異動年月日申請を送信してもよろしいですか？");
    
        if (!isConfirmed) {
            return; 
        }

        const payload = {
            applicationDate: formData.applicationDate,
            reason: formData.reason,
        }

        try {
            await api.post('/api/forms/submit_remove/', payload);
            localStorage.removeItem(DRAFT_KEY);
            alert(
                applicationSuccessMessage('異動年月日が正常に提出されました。', [
                    '申請一覧から内容・状態を確認できます。',
                ])
            );
            navigate('/applications');

        } catch (error) {
            console.error('Submission failed:', error);
            alert('申請に失敗しました。もう一度お試しください。');
            setFormData({
                applicationDate: '',
                reason: ''
            });
        }
    };

    const handleSaveDraft = () => {
        localStorage.setItem(DRAFT_KEY, JSON.stringify(formData));
        alert('一時保存しました。');
    };

    const handleDeleteDraft = async () => {
        const confirmDelete = window.confirm("この下書き（一時保存データ）を削除してもよろしいですか？\n※削除すると元に戻せません。");
        if (!confirmDelete) return;

        setLoading(true);
        try {
            if (id) {
                await api.delete(`/api/applications/drafts/${id}/`);
            }    
            // ローカルでも削除
            localStorage.removeItem(DRAFT_KEY);
            alert('下書きを削除しました。');
            navigate('/applications');
        } catch (error) {
            console.error('下書きの削除に失敗:', error);
            alert('下書きの削除に失敗しました。もう一度お試しください。');
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => { if (onBack) onBack(); else navigate('/applications'); };

    const canSubmit = useMemo(
        () => Boolean(formData.applicationDate && formData.reason?.trim()),
        [formData.applicationDate, formData.reason]
    );

    return (
        <div className="container form-container">
            <h3>異動年月日</h3>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="applicationDate" className="form-label">異動年月日</label>
                    <input type="date" id="applicationDate" name="applicationDate" className={requiredFieldClass(formData.applicationDate)} value={formData.applicationDate} onChange={handleInputChange} required />
                </div>
                <div className="mb-3">
                    <label htmlFor="reason" className="form-label">理由</label>   
                    <input type="text" id="reason" name="reason" className={requiredFieldClass(formData.reason)} value={formData.reason} onChange={handleInputChange} required />
                </div>
                
            
            <div className="button-group">
                <button type="submit" className="btn-submit" disabled={!canSubmit}>申請</button>
                <button type="button" className="btn-draft" onClick={handleSaveDraft}>一時保存</button>
                {((id && isDraft) || localStorage.getItem(DRAFT_KEY)) && <button type="button" className="btn-delete-draft" onClick={handleDeleteDraft} disabled={loading}>下書削除</button>}
                <button type="button" className="btn-back" onClick={handleBack}>{onBack && !isFirstForm ? '前へ' : '戻る'}</button>
                {isMultiForm && onNext && <button type="button" className="btn-nav" onClick={onNext}>{isLastForm ? '完了' : '次へ'}</button>}
            </div>
            </form>
        </div>

    )
};

export default RemoveForm;